import axios from 'axios'
export default {
    namespaced: true,
    state: {
		endpoint: '/vehicle/category',
        items: [],
    },
    actions: {
		load (context) {
			return axios.get(context.getters.endpoint).then(response => {
				//console.log(this.$options.name, 'onSearch','response.data', response.data)
				context.commit('items', response.data.filter((element) => ['CAR','TRUCK'].includes(element.code)))
			}, error => {
				console.log(error)
			})
		},
    }
}